import TitlePage from "@components/atoms/TitlePage/TitlePage";
import GenericTable from "../GenericTable/GenericTable";
import { IReceiptUI } from "src/types/organisms";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
import Report from "@components/molecules/Report/Report";
import ReceiptFilters from "@components/molecules/ReceiptFilters/ReceiptFilters";
const ReceiptsUI = ({
  isLoading,
  showError,
  closeError,
  errorMessage,
  headers,
  rows,
  onClick,
  pages,
  currentPage,
  onChangePage,
  onSearch,
  onSearchClick,
  isAdmin,
  handleStatusFilter,
  handleExpiredFilter
}: IReceiptUI) => {
  return <>
      <TitlePage title="Recibos de caja" subtitle="Supervisa el estado de tus recibos y sus clientes de manera centralizada." />
      {isAdmin && <Report />}
      <GenericTable isLoading={isLoading} title="Lista de recibos de caja" buttonLabel="Crear recibo" onClick={onClick} headers={headers} rows={rows} pages={pages} currentPage={currentPage} onChangePage={onChangePage} emptyMessage="Sin recibos encontrados" searchLabel="Buscar cliente" onSearch={onSearch} onSearchClick={onSearchClick} moreFilters={<ReceiptFilters handleExpiredFilter={handleExpiredFilter} handleStatusFilter={handleStatusFilter} />} />
      <ErrorAlert open={showError} onClose={closeError} message={errorMessage} />
    </>;
};
export default ReceiptsUI;